import React from 'react';
import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { useHistory, useLocation } from 'react-router-dom';
import BusinessIcon from '@mui/icons-material/Business';
import PeopleIcon from '@mui/icons-material/People';
import SupportIcon from '@mui/icons-material/Support';
import ReviewIcon from '@mui/icons-material/RateReview';
import LibraryIcon from '@mui/icons-material/LibraryBooks';
import GalleryIcon from '@mui/icons-material/PhotoLibrary';
import StarIcon from '@mui/icons-material/Star';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

function SidebarItem({ path, icon, text, disabled }) {
  const history = useHistory();
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname.includes(path);
  };

  const handleNavigate = (path) => {
    history.push(path);
  };

  return (
    <ListItemButton
      onClick={() => handleNavigate(path)}
      selected={isActive(path)}
      disabled={disabled}
    >
      <ListItemIcon>{icon}</ListItemIcon>
      <ListItemText primary={text} />
    </ListItemButton>
  );
}

export default function Sidebar() {
  return (
    <React.Fragment>
      <SidebarItem path="/admin/companies" icon={<BusinessIcon />} text="Empresas" />
      <SidebarItem path="/admin/calendar" icon={<CalendarMonthIcon />} text="Calendario" />
      <SidebarItem path="/admin/students" icon={<PeopleIcon />} text="Estudiantes" />
      <SidebarItem path="/admin/feedback" icon={<ReviewIcon />} text="Feedback"/>
      <SidebarItem path="/admin/library" icon={<LibraryIcon />} text="Biblioteca Virtual" />
      <SidebarItem path="/admin/messages" icon={<LibraryIcon />} text="Mensajes" />
      <SidebarItem path="/admin/rewards" icon={<StarIcon />} text="Recompensas" />
      <SidebarItem path="/admin/gallery" icon={<GalleryIcon />} text="Galería" disabled={true} />
      {/* <SidebarItem path="/admin/support" icon={<SupportIcon />} text="Soporte" /> */}
    </React.Fragment>
  );
}
